<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t('deposit_promotion.head') }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t('deposit_promotion.head_list') }} </v-card-title>
        <v-card-actions class="pb-0 d-flex align-start">
          <v-row no-gutters>

            <span style="display: flex; margin-left: 5px;">
              <date-picker-input ref="startDate" :date="dateFrom" :label="$t('report_bonus.date_from')"
                @setValue="dateFrom = $event" style="max-width: 250px;" />
            </span>
            <span style="display: flex; margin-left: 5px;">
              <date-picker-input ref="endDate" :date="dateTo" :label="$t('report_bonus.date_to')"
                @setValue="dateTo = $event" style="max-width: 250px;" />
            </span>
            <span style="display: flex; margin-left: 5px;">
                <v-select v-model="promotion" :label="$t('deposit_promotion.promotion')" :items="promotions" item-text="label" outlined
                dense />
            </span>
            <v-btn color="primary" @click="searchDepositPromotion" class="" style="margin-left: 5px;"> {{ $t('search') }} </v-btn>
            <v-btn color="warning" @click="preloadExportCsv" class="">{{ $t("user.export_excel") }}</v-btn>
          </v-row>
        </v-card-actions>
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :no-data-text="$t('not_found')"
            :no-results-text="$t('not_found')" :options.sync="pagination" :server-items-length="pagination.totalItems"
            :items-per-page="pagination.rowsPerPage" :loading="loading" :page.sync="pagination.currentPage" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :items="members">

            <template v-slot:[`item.amount`]="{ item }">
              {{ item.amount | currency }}
            </template>
          </v-data-table>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import store from '@/store';
export default {
  components: {
    DatePickerInput,
    SelectInput,
  },
  data() {
    return {
      dateFrom: moment().subtract(3, 'days').format('YY-MM-DD'),
      dateTo: moment().format('YY-MM-DD'),
      date: null,
      currentMemberDetail: {},
      searchData: null,
      time: null,
      time2: "00:00",
      time3: "23:59",
      menu2: false,
      modal2: false,
      menu3: false,
      modal3: false,
      valPartner: "พันธมิตร",
      valType: "ทั้งหมด",
      headers: [
        {
          text: this.$t('deposit_promotion.header1'),
          value: 'phone',
          width: '200px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('deposit_promotion.header2'),
          value: 'name',
          width: '200px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('deposit_promotion.header3'),
          value: 'amount',
          width: '200px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('deposit_promotion.header4'),
          value: 'bonus',
          width: '200px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('deposit_promotion.header5'),
          value: 'promotion',
          width: '200px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('deposit_promotion.header6'),
          value: 'date',
          width: '200px',
          align: 'center',
          sortable: false,
        },
      ],
      members: [],
      promotions:[{"value":0,"label":this.$t('all')}],
      promotion:0,
      loading: false,
      pagination: {
        currentPage: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
      total: 0,
      dummy: true,
    }
  },
  watch: {
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        // await this.getBonus(newValue.page, newValue.itemsPerPage, this.$refs.startDate.value, this.$refs.endDate.value, this.searchData, this.valPartner, this.valType)
        if (cont) await this.getDepositPromotion(newValue.page, newValue.itemsPerPage, this.$refs.startDate.value, this.$refs.endDate.value, this.searchData, this.valPartner, this.valType)
        if (cont) await this.getDepositPromotion(newValue.page, newValue.itemsPerPage, this.$refs.startDate.value, this.$refs.endDate.value, this.searchData, this.valPartner, this.valType)
      },
      deep: true,
    },
  },
  async created() {
    this.addLogPage()
    this.getPromotion();
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'รายงานฝากโปรโมชัน',
            url: window.location.href,
            detail: 'รายงานฝากโปรโมชัน',
            admin: userSystem.name ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    async getPromotion(page, row, time_from, time_to) {
      this.loading = true
      this.promotions = [{"value":0,"label":this.$t('all')}]
      this.promotions_id = [0]

      const result = await this.$store.dispatch(
          'getPromotion',
          `page=1&rows=100&time_from=${this.formatDateYYYY(this.dateFrom)}&time_to=${this.formatDateYYYY(this.dateTo)}`)

          result.data.forEach(element => {
        this.promotions.push({"value":element.id,"label":element.name})
      })
      this.loading = false
    },
    async searchDepositPromotion() {
      this.dummy = false
      await this.getDepositPromotion(
        1,
        this.pagination.rowsPerPage,
        this.$refs.startDate.value,
        this.$refs.endDate.value,
      )
    },
    async getDepositPromotion(page, row, time_from, time_to) {
      this.loading = true
      this.members = []

      let rs = await this.$store.dispatch('getAccountingDepositPromotion', {
        page: page,
        rows: row,
        time_from: this.formatDateYYYY(time_from) ,
        time_to: this.formatDateYYYY(time_to),
        promotion_id:this.promotion,
      })
      this.pagination.totalItems = rs.count
      this.totalRows = rs.count ? Number(rs.count) : ''
      rs.data.forEach(element => {
        this.members.push({
          phone: element.phone,
          name: element.name,
          amount: element.amount,
          bonus: element.bonus,
          promotion: element.promotion_name,
          date: element.createdAt ? moment(element.createdAt).format('YY-MM-DD HH:mm') : '',
        })
      })
      this.loading = false
    },
    async preloadExportCsv() {
      //////// get logExportData ////////
      let logExportData;
      const userSystem = store.getters.getuserInfo
      await axios.get('https://api.ipify.org?format=json').then(res =>
        logExportData = {
          ip: res.data.ip,
          exportPage: 'บัญชี - รายงานฝากโปรโมชัน',
          url: window.location.href,
          detail: 'ระบบบัญชี',
          admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
        }
      )

      this.$swal({
        title: `Secure code | รายงาน${logExportData.exportPage}`,
        input: 'password',
        // inputAttributes: {
        //   inputmode: 'numeric',
        //   pattern: '[0-9]*',
        //   maxlength: 6,
        // },
        inputValidator: value => {
          if (!value) {
            return 'โปรดกรอก Secure code'
          }
          // if (value && value.length !== 6) {
          //   return 'โปรดกรอกให้ครบ 6 หลัก'
          // }
        },
        inputPlaceholder: 'ใส่รหัสที่นี่...',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ออก',
      }).then(async result => {
        if (result.isConfirmed) {
          const pin = result.value
          let enterSecureData = {
            ...logExportData,
            keyCheck: pin
          }
          this.loading = true
          let resEnterSecureData = await this.$store.dispatch('checkLogEnterSecure', enterSecureData)
          if (resEnterSecureData && resEnterSecureData.secure) {
            this.exportCsv()
          } else {
            this.$swal.fire('ไม่สามารถ download ได้ เนื่องจากรหัส PIN ไม่ถูกต้อง', '', 'error')
          }
          this.loading = false
        }
      })
    },
    async exportCsv() {
      this.$swal.fire({
        html: this.$t("processing"),
        timerProgressBar: true,
        didOpen: () => { this.$swal.showLoading() }
      })

      let fileName = `${this.$t("deposit_promotion.file_name")}_${moment(new Date()).format('YYYY-MM-DD_HH-mm')}`
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const wscols = [
        { wch: 15 },
        { wch: 25 },
        { wch: 10 },
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
        { wch: 15 },
      ];
      let statementlist = []

      let rs = await this.$store.dispatch('getAccountingDepositPromotion', {
        page: 1,
        rows: 1000000,
        time_from: this.formatDateYYYY(this.$refs.startDate.value) ,
        time_to: this.formatDateYYYY(this.$refs.endDate.value),
        promotion_id:this.promotion,
      })
      // console.log(rs.data);
       rs.data.forEach(element => {
        statementlist.push({
          phone: element.phone,
          name: element.name,
          amount: element.amount,
          bonus: element.bonus,
          promotion: element.promotion_name,
          date: element.createdAt ? moment(element.createdAt).format('YY-MM-DD HH:mm') : '',
        })
      })
      let ws = XLSX.utils.json_to_sheet(statementlist);
      ws['!cols'] = wscols;
      const wb = { Sheets: { AccoutingDepoitPromotion: ws }, SheetNames: ["AccoutingDepoitPromotion"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);

      // add log admin export
      await this.addLogExportCSV()
      this.$swal.close()
    },
    async addLogExportCSV() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            exportPage: 'บัญชี',
            url: window.location.href,
            detail: 'ระบบรายงานสมาชกไม่ฝาก',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogExportCSV', data)
      } catch (e) {
        if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
          this.$swal.fire({
            icon: 'error',
            title: e.message,
          })
        }
      }
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
  },
}
</script>
<style scoped>
@import '../../styles/custom.css';
</style>
